import { Interface } from 'ethers'

/** `DcaExecutor.Order`, field order as declared on-chain (DCA client doc §5.1). */
const ORDER_TUPLE =
  '(address owner, uint32 nextExecutableAt, uint32 lastExecutedAt, uint16 totalExecutions, uint16 executedCount, address tokenIn, uint32 interval, uint32 deadline, uint16 maxSlippageBps, uint16 feeBps, address tokenOut, uint32 version, uint8 status, uint128 amountPerExecution, uint128 executionFee)'

/** On-chain `Order.status`: 0 None, 1 Active, 2 Paused, 3 Completed, 4 Cancelled. */
export const ONCHAIN_ORDER_STATUS = { ACTIVE: 1, PAUSED: 2 } as const

/** The user-callable part of `DcaExecutor` plus its custom errors (DCA client doc §5.1). */
export const DCA_EXECUTOR_INTERFACE = new Interface([
  'function createOrder((address tokenIn, address tokenOut, uint128 amountPerExecution, uint32 interval, uint16 totalExecutions, uint32 startTime, uint32 deadline, uint16 maxSlippageBps, uint16 maxFeeBps, uint128 maxExecutionFee) params) returns (uint256 orderId)',
  'function pauseOrder(uint256 orderId)',
  'function resumeOrder(uint256 orderId)',
  'function cancelOrder(uint256 orderId)',
  `function getOrder(uint256 orderId) view returns (${ORDER_TUPLE})`,
  `event OrderCreated(uint256 indexed orderId, address indexed owner, ${ORDER_TUPLE} order)`,
  'error NotOrderOwner()',
  'error NotInitialized()',
  'error EnforcedPause()',
  'error InvalidStatus(uint8 status)',
  'error InvalidToken()',
  'error InvalidAmount()',
  'error InvalidInterval()',
  'error InvalidExecutions()',
  'error InvalidSlippage()',
  'error InvalidSchedule()',
  'error FeeTooHigh()',
  'error OrderExpired(uint32 deadline)'
])

export const ERC20_APPROVE_INTERFACE = new Interface([
  'function approve(address spender, uint256 amount) returns (bool)',
  'function allowance(address owner, address spender) view returns (uint256)',
  'function symbol() view returns (string)',
  'function decimals() view returns (uint8)'
])

/** `WPLS.deposit()` — the whole calldata, it takes no arguments. */
export const WRAP_NATIVE_CALLDATA = '0xd0e30db0'
